import CardsSection from "../../../components/PageManagment/CardsSection"
import PageManagementHeader from "../../../components/PageManagment/PageManagmentHeader"
import styles from "./PageManagementScreen.module.css"

const PageManagementScreen = () => {
  return (
    <div className={styles.container}>
        <CardsSection/>
    </div>
  )
}

export default PageManagementScreen
